var map = {
	"./assustado.png": 2684,
	"./falando.png": 8602,
	"./falando2.png": 4242,
	"./falando_feliz.png": 8603,
	"./falando_feliz2.png": 5121,
	"./feliz.png": 9273,
	"./normal.png": 6052,
	"./sorriso.png": 5624,
	"./sorriso2.png": 6936,
	"./triste.png": 4398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6664;